import React from 'react'
import { withStyles } from '@material-ui/core/styles'

const styles = {
  spinnerStyle: {
    boxSizing: 'border-box',
    width: '64px',
    height: '64px',
    borderRadius: '100%',
    border: '8px solid #d6d8db',
    borderTopColor: '#303c49',
    animation: 'spin 0.75s infinite linear',
    margin: '0px auto'
  }
}

const Spinner = ({ classes: { spinnerStyle } }) => (
  <div
    style={{
      flexGrow: 1,
      padding: '75px 35px'
    }}
  >
    <div className={spinnerStyle} />
  </div>
)

export default withStyles(styles)(Spinner)



// WEBPACK FOOTER //
// ./src/components/Spinner.js